<template>
  <header>

    <nav>
      <ul>
        

        <li :class="[ currentRouteName == 'Home' ? 'selected' : '']">
          <div><router-link to="/">
            <img class="" src="@/assets/visita-guidata/icon-home.svg" alt="" />
            Home</router-link>
          </div>
        </li>

        <li @click="openCloseMenuLanguages()">
          <ul>
            <li class="selected">
              <img v-if="this.$store.state.currentLang == 'it'" class="lang" src="@/assets/lang-it.svg" alt="" />
              <div v-if="this.$store.state.currentLang == 'it'">it</div>

              <img v-if="this.$store.state.currentLang == 'en'" class="lang" src="@/assets/lang-en.svg" alt="" />
              <div v-if="this.$store.state.currentLang == 'en'">en</div>

              <img v-if="this.$store.state.currentLang == 'de'" class="lang" src="@/assets/lang-de.svg" alt="" />
              <div v-if="this.$store.state.currentLang == 'de'">de</div>

              <img :class="[this.openMenuLang ? 'open' : '']" class="arrow"
                src="@/assets/visita-guidata/icon-arrow-dropdown.svg" alt="" />
            </li>
          </ul>
        </li>

        <li :class="[ currentRouteName == 'LaStoriaAttraversoIReperti' ? 'selected' : '']">
          <div>
            <img class="" src="@/assets/visita-guidata/icon-info.svg" alt="" />
            <router-link to="/la-storia-attraverso-i-reperti">info</router-link>
          </div>
        </li>
      </ul>
    </nav>

    <nav :class="['language-list', this.openMenuLang ? 'open' : '']">
      <ul>

        <li :class="['de', this.$store.state.currentLang == 'it' ? 'selected' : '']" @click.prevent="changeLang('it')">
          <img class="lang" src="@/assets/lang-it.svg" alt="" />
          <div>italiano</div>
        </li>

        <li :class="['de', this.$store.state.currentLang == 'en' ? 'selected' : '']" @click.prevent="changeLang('en')">
          <img class="lang" src="@/assets/lang-en.svg" alt="" />
          <div>english</div>
        </li>

        <li :class="['de', this.$store.state.currentLang == 'de' ? 'selected' : '']" @click.prevent="changeLang('de')">
          <img class="lang" src="@/assets/lang-de.svg" alt="" />
          <div>deutsch</div>
        </li>

      </ul>
    </nav>
  </header>
</template>
<script>
export default {
  name: 'the-header',
  data() {
    return {
      windowScrolled: false,
      menuOpen: false,
      submenuOpen: null,
      openMenuLang: false,
      submenuVisible: true,
      menuItems: []
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
    lang() {
      return this.$store.state.currentLang
    },
    defaultLang() {
      return this.$store.state.defaultLang
    }
  },
  methods: {
    openCloseMenuLanguages() {
      this.openMenuLang = !this.openMenuLang
    },
    changeLang(l) {
      this.$store.commit('SET_CURRENT_LANG', l)
      this.openCloseMenuLanguages()
    },
    async fetchMenuItems() {
      console.log('VUE_APP_ENDPOINT', process.env.VUE_APP_ENDPOINT);
      var menu = []
      var items = []
      var ch = []

      var l = this.lang != this.defaultLang ? ('/' + this.lang) : ''

      await fetch(`${process.env.VUE_APP_ENDPOINT}${l}/jconfig/menu/main`)
        .then(res => res.json())
        .then(json => {
          items = json.menu.sort((a, b) => { return a.weight > b.weight ? -1 : 1 })
        })

      //for each fetched route
      items.forEach(item => {
        ch = []

        //for each menu item with no parent 
        //if the number of its children is 0
        if (!item.hasChildren) {
          //push it into the menu as a top-level route
          menu.push({
            label: item.title,
            url: item.url
          })

        } else {
          item.subtree.forEach(child => ch.push({
            label: child.title,
            url: child.url
          }))

          //then push them into the menu as a sub-level route (for that corresponding top-level menu)
          menu.push({
            label: item.attributes.title,
            children: ch
          })
        }
      })

      //create the menu
      this.menuItems = menu
    },
    toggleMenu() {
      if (this.menuOpen)
        this.closeMenu()
      else
        this.openMenu()

      this.openSubmenu(null)
    },
    openMenu() {
      document.body.classList.add('noscroll')
      //document.querySelector("html").classList.add("menu-open");
      document.body.classList.add("menu-open");
      document.getElementById('check').checked = true
      this.menuOpen = true;

      //console.log('open menu')
    },
    closeMenu() {
      document.body.classList.remove('noscroll')
      //document.querySelector("html").classList.remove("menu-open");
      document.body.classList.remove("menu-open");
      document.getElementById('check').checked = false
      this.openSubmenu(null)
      this.menuOpen = false

      //console.log('close menu')

      this.hideSubmenu()
    },
    hideSubmenu() {
      // hide temporary sub menu after click
      this.submenuVisible = false
      setTimeout(() => {
        this.submenuVisible = true
      }, 100)
    },
    //just one submenu can stay open at a time
    openSubmenu(index) {
      //console.log(index)
      if (this.submenuOpen === index)
        this.submenuOpen = null
      else
        this.submenuOpen = index
    },
    handleScroll() {
      if (window.pageYOffset)
        this.windowScrolled = true
      else
        this.windowScrolled = false
    },
    change(ev) {
      this.changeLang(ev.target.value)
    }
  },
  created() {
    this.fetchMenuItems();
    window.addEventListener('scroll', this.handleScroll);
  },
  watch: {
    lang() {
      this.fetchMenuItems();
    }
  }
};
</script>

<style lang="scss" scoped>

  header {
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #181923;
    z-index: 100;
    border-bottom: 1px solid #445068;

    nav {
      border-bottom: 1px solid #445068;

      > ul {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        align-items: stretch;

        > li {
          width: 33.333333%;
          display: flex;
          justify-content: center;
          align-items: baseline;
          text-transform: uppercase;
          border-right: 1px solid #445068;
          padding: 15px 0px 11px 0px;
          color: #fff;

          a {
            text-decoration: none;
            color: #fff;
          }

          &.selected {
            border-bottom: 2px solid #C79641;
          }

          .arrow {
            top: -1px;
            left: 11px;
            width: 11px;

            &.open {
              transform: rotate(180deg);
              transform-origin: center;
            }
          }

          .lang {
            top: -1px;
            left: -6px;
          }

          img {
            position: relative;
            top: 1px;
            left: -6px;
            height: 14px;
          }

          img.lang {
            width: auto;
            height: 20px;
          }

          &:last-child {
            border-right: 0px solid #445068;
          }

          img.lang {
            width: 20px;
            height: auto;
          }

          ul {
            li {
              font-size: 14px;
              padding: 0;
              display: none;
            }

            li.selected {
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
    }
  }

  .language-list {
    display: none;
    border: 0px solid #445068;

    &.open {
      display: block;
    }

    ul {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      li {
        width: 100%;
        list-style: none;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        text-transform: uppercase;
        padding: 20px 0px;
        border-bottom: 1px solid #445068;

        img {
          position: relative;
          top: -2px;
          left: -8px;
        }

        &:last-child {
          border-bottom: 0px solid #445068;
        }

        &.selected {
          background-color: #fff;
          color: #181923;
          border-bottom: 0px solid #C79641;
        }
      }
    }
  }
</style>